import React, { FC, Fragment, ReactNode } from "react";
import { Helmet } from "react-helmet-async";
import { PageNamesUnion } from "src/@types/pagesMetadata";
import { useAppSelector } from "src/hooks/redux";
import { selectMetaDataState } from "src/redux/metadata/selectors";

type ImplicitMetaProps = {
  name: PageNamesUnion;
  title?: never;
  description?: never;
  children: ReactNode;
};

type ExplicitMetaProps = {
  name?: never;
  title: string;
  description: string;
  children: ReactNode;
};

type Props = ImplicitMetaProps | ExplicitMetaProps;

export const MetadataWrapper: FC<Props> = ({
  name,
  title,
  description,
  children,
}) => {
  const { data } = useAppSelector(selectMetaDataState);
  const metadata = name ? data?.[name] : { title, description };

  return (
    <Fragment>
      <Helmet>
        <title>{metadata?.title || "Business Clone"}</title>
        <meta name="description" content={metadata?.description || ""} />
      </Helmet>
      {children}
    </Fragment>
  );
};
